<template>
  <div>
    <Breadcrumbs />
    
    <section class="page-content">
      <div class="wrapper with-sidebar mt-5 mb-5 pb-5"> 
      <div class="category-listing row m-0">

        <div class="col-12 col-md-3 wrapper with-sidebar mt-0 mb-0 pb-0 mb-xl-5 pb-xl-5">
          <BrandFilterMobile />
        </div>
        <div class="category-listing-inner col-12 col-lg-9 container">
          <template>
            <!-- Brand Details -->
            <b-row v-if="brandDetail">
              <b-col cols="12">
                <h1 class="page-heading main-category-title" v-if="brandDetail && brandDetail.title">

                </h1>
                <p class="text-dark" v-if="brandDetail && brandDetail.shortDescription"
                  v-html="brandDetail.shortDescription"></p>
              </b-col>
            </b-row>

            <FilterBrands :viewAsCheck="viewAsCheck" @update:viewAsCheck="viewAsCheck = $event" />
            <!-- <BrandSliderComponent /> -->

            <!-- Top Filters -->

            <!-- Products -->
            <b-row v-if="isLoading" class="pro-loader">
              <div class="reverse-spinner"></div>
            </b-row>

            <b-row v-else-if="totalProducts === 0">
              <b-col>
                <p class="text-center">{{ $t("no_products") }}</p>
              </b-col>
            </b-row>


            <b-row class="category-products-grid product-pages-category grid-row row row-cols-2 row-cols-md-3"
              :class="gridClass" id="category-products-grid" v-else>
              <b-col v-for="(product, index) in products" :key="index" class="category-products-item ">
                <ProductCard :product="product" />
              </b-col>

            </b-row>
            <FilterBrands class="bottom-pagination" />
            <!-- <div v-if="totalProducts > 0" class="filter-wrapper mb-4">
            <CategoryPageContentFilter v-if="totalProducts > 0" />
          </div> -->
            <!-- Bottom Section (pagination/filter) -->
            <!-- <div v-if="totalProducts > 0" class="pb-30 pagination-header category-right-top-list-header mt-0">
            <div class="category-list-left">
              {{ totalProducts }} {{ $t("result") }} | &nbsp;
              {{ $t("sort_by") }}
              <span class="count-icon">
                <select id="collection" class="filter-list bold" :value="sorting" @change="changeSorting">
                  <option v-for="option in selectOptions" v-bind:key="option.value" v-bind:value="option.value">
                    {{ option.text }}
                  </option>
                </select>
              </span>
            </div>
            <div class="category-list-right pagination-wrap">
              <b-pagination :value="pageInfo.current_page" @change="changePage($event)" :per-page="pageInfo.page_size"
                :total-rows="totalProducts" :limit="3" :prev-class="{ 'd-none': pageInfo.current_page == 1 }"
                :next-class="{
                  'd-none':
                    pageInfo.current_page ==
                    Math.ceil(totalProducts / pageInfo.page_size),
                }">
                <template #page="{ page }">
                  <b-link @click="goToPage(page, $event)" ref="paginationLink">
                    {{ page }}
                  </b-link>
                </template>
</b-pagination>
</div>
</div> -->


            <!-- Category Description -->

            <div v-html="brandDetail.description" class="product-page-description products-des-space"
              v-if="brandDetail && brandDetail.description"></div>
          </template>
        </div>
      </div>
      </div>
    </section>
  </div>
</template>

<script>
import config from "@config";
import ProductCard from "@/esf_antarctica_lederhosenland/core/components/category-product/ProductCard.vue";
import FilterBrands from "@/esf_antarctica_lederhosenland/core/components/brands/FilterBrands.vue";
import Breadcrumbs from "@/esf_antarctica_lederhosenland/core/components/breadcrumb/Breadcrumbs";
import BrandFilterMobile from "./BrandFilterMobile.vue";

export default {
  name: "BrandPageContent",

  data() {
    return {
      isLoading: true,
      viewAsCheck: 4,
    };
  },

  components: {
    ProductCard,
    FilterBrands,
    BrandFilterMobile,
    Breadcrumbs
  },

  metaInfo() {
    return {
      title: this.brandDetail?.title || "Brand Details",
    };
  },

  computed: {
    gridClass() {
      return {
        'grid-row row-cols-xl-2 view-as-2 view-2-columns': this.viewAsCheck === 2,
        'grid-row row-cols-xl-3 view-as-3 view-3-columns': this.viewAsCheck === 3,
        'grid-row row-cols-xl-4 view-as-4 view-4-columns': this.viewAsCheck === 4
      };
    },
    brandDetail() {
      return this.$store.getters["product/getBrandDetailData"];
    },

    products() {
      const allProducts = this.$store.getters["product/getBrandProducts"] || [];

      return allProducts.filter(
        (product) =>
          product &&
          typeof product === "object" &&
          Object.keys(product).length > 0
      );
    },

    pageInfo() {
      return this.$store.getters["product/getBrandPageInfo"] || {};
    },

    totalProducts() {
      return this.$store.getters["product/getBrandProductsTotalCount"] || 0;
    },

    sorting() {
      return this.$store.getters["product/getSorting"];
    },

    selectOptions() {
      const sortOpt = [];
      Object.keys(config.sortingOptions).forEach((element) => {
        const option = {
          value: element,
          text: this.$t(`sortingOptions.${element}`),
        };
        sortOpt.push(option);
      });
      return sortOpt;
    },
  },

  mounted() {
    this.fetchBrand();
  },
  watch: {
    "$route.params.code": function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.isLoading = true;
        this.fetchBrand();
      }
    }
  },

  methods: {

    // Change the pagination
    changePage(pageNo) {
      localStorage.setItem("v-remember-scroll-position", window.scrollY);
      localStorage.setItem("v-remember-scroll-page", window.location.pathname);

      this.$store.dispatch("product/updateCurrentPage", pageNo);
    },

    goToPage(page) {
      localStorage.setItem("v-remember-scroll-position", window.scrollY);
      localStorage.setItem("v-remember-scroll-page", window.location.pathname);
      const query = { ...this.$route.query };

      if (page != 1) query["page"] = page;
      else delete query["page"];
    },

    // Fetch the specific brand details and its products
    async fetchBrand() {
      const key = this.$route.params.code;
      const retval = await this.$store.dispatch("product/getBrandDetail", {
        urlKey: key,
      });

      // Get products
      if (retval) {
        await this.$store.dispatch("product/getProductByBrand");
        this.isLoading = false;
         this.setBreadcrumb();
      } else {
        console.error("Error fetching brand detail");
      }
    },
     setBreadcrumb() {
      const brandName = this.brandDetail?.title || this.$route.params.code;
      const bcrumb = {
        current: brandName,
        routes: [
          { name: this.$t("brands"), link: "/brands" },
        ],
      };
      this.$store.commit("breadcrumbs/set", bcrumb);
    },


    // Get the products as per sorting
    changeSorting(event) {
      const sortVal = event.target.value;
      this.$store.commit("product/setSorting", sortVal);
    },

    // Change the product size on page
    changePerPage(event) {
      const perPage = +event.target.value;
      this.$store.commit("product/setProductsPerPage", perPage);
    },
  },
};
</script>

<style lang="scss"></style>
